import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCross = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "7px",
	height: "7px",
	viewBox: "0 0 7 7",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "53837FCC-2B3B-4D7B-A57F-8B9E6867801D"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "UI",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Gydytoj\\u0173-s\\u0105ra\\u0161as",
			transform: "translate(-1182.000000, -526.000000)",
			fill: "#000000",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group-6",
				transform: "translate(1179.000000, 520.000000)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M7,5 L7,9 L11,9 L11,10 L7,10 L7,14 L6,14 L6,10 L2,10 L2,9 L6,9 L6,5 L7,5 Z",
					id: "delete",
					transform: "translate(6.500000, 9.500000) rotate(-315.000000) translate(-6.500000, -9.500000) "
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgCross);
export default ForwardRef;
